import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { muscatineConfig } from "./data";

export default function MuscatinePage() {
  return <CityPageTemplate config={muscatineConfig} />;
}